import { render, staticRenderFns } from "./EventHomeView.vue?vue&type=template&id=5fa46092"
import script from "./EventHomeView.vue?vue&type=script&lang=js"
export * from "./EventHomeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports